<div class="selection-dialog-container">

    <div class="selection-header">
        <div class="header-text">
            <div><span style="font-weight: 600;">Select Custom Analysis Sequence Items</span></div>
            <div><button class="clear-all-btn" *ngIf="selectedItems.length > 0" mat-stroked-button (click)="clearAll()">Clear All</button></div>
        </div>

        <div class="close-icon" (click)="close()">X</div>
    </div>

    <!-- Selected items chips -->
    <div class="selected-items-bar" *ngIf="selectedItems.length > 0">
        <div class="selected-chip" *ngFor="let item of selectedItems">
            <p class="selected-chip-text">{{item.type}} - {{formatDate(item.datePerformed, 'YYYY-MM-DD')}}
                <span *ngIf="!item.type.toLowerCase().includes('satellite') && !item.type.toLowerCase().includes('topography') && item.items[0]?.propertyTypeName"> | {{item.items[0].propertyTypeName}}</span>
            </p>
            <div class="remove-chip" (click)="removeSelected(item)">x</div>
        </div>
    </div>

    <mat-divider></mat-divider>

    <div class="selection-body">

        <!-- Type sidebar -->
        <div class="type-sidebar">
            <div class="type-nav">
                <mat-list style="padding:0!important" *ngFor="let type of analysisTypes | orderBy: 'name'">
                    <mat-list-item
                        [disabled]="!type.available"
                        class="type-item"
                        (click)="selectType(type)"
                        [ngClass]="{'type-item-selected': type.selected === true}">
                        <a>{{type.alias}}</a>
                    </mat-list-item>
                </mat-list>
            </div>
        </div>

        <!-- List area -->
        <div class="list-area">

            <!-- Period toggles -->
            <mat-button-toggle-group *ngIf="!disablePeriodRange" #periodGroup="matButtonToggleGroup"
                class="period-toggle-group" [value]="selectedPeriod" (change)="clickPeriod(periodGroup.value)">
                <div class="period-btn-row">
                    <mat-button-toggle class="period-btn" value="30 days">30 Days</mat-button-toggle>
                    <mat-button-toggle class="period-btn" value="3 months">3 Months</mat-button-toggle>
                    <mat-button-toggle class="period-btn" value="6 months">6 Months</mat-button-toggle>
                    <mat-button-toggle class="period-btn" value="all">All</mat-button-toggle>
                </div>
            </mat-button-toggle-group>

            <div class="items-list-container">

                <!-- Satellite / Topography list -->
                <div *ngIf="showAnalysisList">
                    <div class="list-row" *ngFor="let item of filteredList"
                         (click)="toggleItem(item)"
                         [ngClass]="{'list-row-selected': isSelected(item)}">
                        <mat-checkbox [checked]="isSelected(item)" (click)="$event.stopPropagation()" (change)="toggleItem(item)"></mat-checkbox>
                        <p class="list-row-text">
                            {{ item.type.toLowerCase().includes('topography') ? formatDate(item.datePerformed, 'YYYY') : item.datePerformed }}
                        </p>
                    </div>

                    <div class="load-more-container"
                         *ngIf="showAnalysisList && !hideLoadMoreBtn && showNoDataCard">
                        <button class="load-more-btn" mat-flat-button (click)="loadMore()">Load More</button>
                    </div>
                </div>

                <!-- Chemical / expandable list -->
                <div *ngIf="showChemList">
                    <mat-expansion-panel class="chem-panel" *ngFor="let item of filteredList">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="chem-panel-title">
                                {{formatDate(item.datePerformed, 'YYYY')}}
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div class="chem-item-row" *ngFor="let subItem of item.items; let i = index"
                             (click)="toggleChemItem(item, i)"
                             [ngClass]="{'list-row-selected': isChemItemSelected(item, i)}">
                            <mat-checkbox [checked]="isChemItemSelected(item, i)" (click)="$event.stopPropagation()" (change)="toggleChemItem(item, i)"></mat-checkbox>
                            <label class="chem-item-label">{{subItem.propertyTypeName}}</label>
                        </div>
                    </mat-expansion-panel>
                </div>

                <!-- No data -->
                <div *ngIf="!showNoDataCard" class="no-data-message">
                    <p>No data available for the selected type and period.</p>
                </div>
            </div>
        </div>
    </div>

    <mat-divider></mat-divider>

    <div class="selection-footer">
        <span class="selected-count">{{selectedItems.length}} item(s) selected</span>
        <button mat-flat-button [disabled]="selectedItems.length === 0" (click)="confirm()">
            Add to Sequence
        </button>
    </div>

</div>
